'use client';

import { useEffect, useState } from 'react';

/**
 * 숨김 공개 중 탭 줄 표시용 '주소로 들어온 사람' 표시 (#316 note_343209).
 * /saenggibu 를 연 방문자의 이 브라우저 세션(탭을 닫으면 사라짐)에만 남긴다.
 * 서버에는 아무것도 보내지 않는다. 다른 방문자에게는 탭이 보이지 않는다.
 */
const KEY = 'saenggibu-seen';
const EVT = 'saenggibu-seen-change';

export function markSaenggibuSeen(): void {
  try {
    window.sessionStorage.setItem(KEY, '1');
  } catch {
    // 저장소를 못 쓰는 환경(사생활 보호 창 등)에서는 표시가 남지 않을 뿐이다.
  }
  window.dispatchEvent(new Event(EVT));
}

/** 마운트 뒤에 읽는다(서버 렌더와 어긋나지 않도록 처음엔 false). */
export function useSaenggibuSeen(): boolean {
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const read = () => {
      try {
        setSeen(window.sessionStorage.getItem(KEY) === '1');
      } catch {
        setSeen(false);
      }
    };
    read();
    window.addEventListener(EVT, read);
    return () => window.removeEventListener(EVT, read);
  }, []);
  return seen;
}
